"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateModelMetaFields = exports.CreateModelMetaFields = exports.ModelMetaFields = exports.DateMetaFields = exports.IdSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const time_1 = require("./time");
exports.IdSchema = typebox_1.Type.Integer({
    title: "Id",
    description: "Unique reference",
    // System user runs as id: 0
    minimum: 0,
});
exports.DateMetaFields = {
    createdAt: time_1.TimestampSchema,
    updatedAt: time_1.TimestampSchema,
    deletedAt: typebox_1.Type.Optional(time_1.TimestampSchema),
};
/**
 * Additional information about the model from the database
 */
exports.ModelMetaFields = {
    id: exports.IdSchema,
    ...exports.DateMetaFields,
};
/**
 * Model metadata which could be sent on POST / create.
 *
 * It's empty but it's just for consistency.
 */
exports.CreateModelMetaFields = {
// Empty
};
/**
 * Model metadata which could be sent on PUT / update.
 *
 * We don't want to return BadRequest if a client was to call  GET and then send everything to PUT.
 *
 * We might move to require updatedAt since we could use that to verify the 'version' of the data hasn't changed.
 */
exports.UpdateModelMetaFields = {
    id: exports.IdSchema,
    createdAt: typebox_1.Type.Optional(time_1.TimestampSchema),
    updatedAt: typebox_1.Type.Optional(time_1.TimestampSchema),
    deletedAt: typebox_1.Type.Optional(time_1.TimestampSchema),
};
